// extracted by mini-css-extract-plugin
module.exports = {"credit":"credit--3hDzO","text":"text--3Dxzv"};